<div class="content" *ngIf="business$ | async as business; else loading">
  <div class="row align-items-center mb-4">
    <div class="col-sm-6">
      <h6 class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
        <!-- <a [routerLink]="['/company/business']"> -->
        <a href="javascript:void(0);" (click)="goBack()">
          <i class="ti ti-arrow-left me-2"></i>Business Entities</a
        >
        <span class="text-gray d-inline-flex ms-2">/ {{ business.businessName }}</span>
      </h6>
    </div>
    <div class="col-sm-6">
      <div class="d-flex align-items-center justify-content-sm-end">
        <a
          *appHasPermission="{ business: ['edit'] }"
          href="javascript:void(0);"
          class="btn btn-primary d-inline-flex align-items-center me-2"
          (click)="openBusinessModal(assingBusinessOwnerModal)"
        >
          <i class="ti ti-circle-plus me-2"></i>Change Owner
        </a>
        <a
          *appHasPermission="{ employees: ['add'] }"
          href="javascript:void(0);"
          class="btn btn-primary d-inline-flex align-items-center me-2"
          (click)="openBusinessModal(addEmployeeModals)"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Employee
        </a>
        <a href="javascript:void(0);" class="btn btn-dark d-inline-flex align-items-center d-none"
          ><i class="ti ti-mail me-2"></i>Send Email</a
        >
        <div class="head-icons ms-2 mb-0 d-none">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-4 theiaStickySidebar">
      <div class="card card-bg-1">
        <div class="card-body p-0">
          <span class="avatar avatar-xl border bg-white rounded-circle m-auto d-flex mb-2">
            <!-- <img
              [src]="businessImages[business.picture] || defaultImg"
              class="img-fluid rounded-circle"
              alt="Img"
            /> -->
            <ng-container
              *ngIf="business.picture && businessImages[business.picture]; else initials"
            >
              <img
                [src]="businessImages[business.picture]"
                (error)="onImageError(business)"
                class="rounded-circle"
                alt="img"
                style="width: 100%; height: 100%; object-fit: cover"
              />
            </ng-container>

            <ng-template #initials>
              <span
                class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                style="width: 50px; height: 50px"
                >{{ getInitials(business.businessName) }}</span
              >
            </ng-template>
          </span>
          <div class="text-center px-3 pb-3 border-bottom">
            <h5 class="d-flex align-items-center justify-content-center mb-1">
              {{ business?.businessName }}
              <i
                *ngIf="!business.disabled"
                class="ti ti-discount-check-filled text-success ms-1"
              ></i>
              <i *ngIf="business.disabled" class="ti ti-ban text-danger ms-1"></i>
            </h5>
            <p class="text-dark">
              {{ business.address }} {{ business.city ? ', ' + business.city.name : '' }}
              {{ business.city && business.city.state ? ', ' + business.city.state.name : '' }}
              {{
                business.city && business.city.state && business.city.country
                  ? ', ' + business.city.country.name
                  : ''
              }}
              {{ business.zipCode ? ', ' + business.zipCode : '' }}
            </p>
          </div>
          <div class="p-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6>Basic information</h6>
              <a
                *appHasPermission="{ business: ['edit'] }"
                href="javascript:void(0);"
                class="btn btn-icon btn-sm"
                (click)="openBusinessModal(addBusinessModals)"
                ><i class="ti ti-edit"></i
              ></a>
            </div>
            <!-- <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-phone me-2"></i>
                Phone
              </span>
              <p class="text-dark">{{business.user.phone}}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-mail-check me-2"></i>
                Email
              </span>
              <a href="javascript:void(0);" class="text-info d-inline-flex align-items-center"><span class="__cf_email__" data-cfemail="eb8f8a99878e8eab8e938a869b878ec5888486">{{business.user.email}}</span> <i class="ti ti-copy text-dark ms-2" (click)="copyContent(business.user.email)"></i></a>
            </div> -->
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-gender-male me-2"></i>
                Owner
              </span>
              <p class="text-dark">
                {{ business.user?.firstName | capitalize }} {{ business.user?.lastName }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-phone me-2"></i>
                Mobile
              </span>
              <p class="text-dark">{{ business.user?.mobile }}</p>
            </div>
          </div>
          <div class="p-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6>Other Information <span class="text-danger"> *</span></h6>
              <!-- <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                ><i class="ti ti-edit"></i
              ></a> -->
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-e-passport me-2"></i>
                Language
              </span>
              <p class="text-dark">English</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-mail-check me-2"></i>
                Currency
              </span>
              <p class="text-dark">
                {{ business.currency?.currency_name }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-globe me-2"></i>
                Created By
              </span>
              <p class="text-dark">
                {{
                  business.createdByuser
                    ? business.createdByuser.firstName + ' ' + business.createdByuser.lastName
                    : 'Automated User'
                }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-gender-male me-2"></i>
                Created On
              </span>
              <p class="text-dark">{{ business.createdAt | date: 'medium' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-globe me-2"></i>
                Last Modified On
              </span>
              <p class="text-dark">{{ business.lastModifiedOn | date: 'medium' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-globe me-2"></i>
                Last Modified By
              </span>
              <p class="text-dark">
                {{ business.lastModifiedByUser ? business.lastModifiedByUser?.firstName : '' }}
                {{ business.lastModifiedByUser ? business.lastModifiedByUser?.lastName : '' }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-bookmark-plus me-2"></i>
                Source
              </span>
              <p class="text-dark">{{ business.source }}</p>
            </div>
          </div>
          <div class="p-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6>Compliance</h6>
              <!-- <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                ><i class="ti ti-edit"></i
              ></a> -->
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-e-passport me-2"></i>
                GST
              </span>
              <p class="text-dark">{{ business.GST }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-mail-check me-2"></i>
                Incorporation Number
              </span>
              <p class="text-dark">
                {{ business.incorporationNo }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-globe me-2"></i>
                Incorporation Date
              </span>
              <p class="text-dark">
                {{ business.incorporationDate | date: 'mediumDate' }}
              </p>
            </div>
          </div>
          <div class="p-3 border-bottom d-none">
            <h5 class="mb-3">Tags</h5>
            <div class="d-flex align-items-center">
              <span class="badge badge-soft-success me-3">Collab</span>
              <span class="badge badge-soft-warning">Rated</span>
            </div>
          </div>
          <div class="p-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5>Offices</h5>
              <a
                href="javascript:void(0);"
                class="text-primary d-inline-flex align-items-center"
                (click)="openBusinessModal(addOfficeModal)"
              >
                <ng-container *appHasPermission="{ employees: ['view'] }">
                  <i class="ti ti-circle-plus me-1"></i>Add New
                </ng-container>
              </a>
            </div>
            <!-- office listing -->
            <div
              class="d-flex align-items-center justify-content-between file-name-icon mb-3"
              *ngFor="let office of offices$ | async"
            >
              <!-- <a href="javascript:void(0);" class="avatar avatar-md border rounded-circle">
              <img src="assets/img/company/company-01.svg" class="img-fluid" alt="img">
            </a> -->
              <div class="ms-2">
                <a [routerLink]="['/company/office', office.id]">
                  <h6 class="fw-medium">{{ office.officeName }}</h6>
                </a>
                <!-- <span class="d-block">{{office.user.email}}</span> -->
              </div>
              <div>
                <a [routerLink]="['/company/office', office.id]" class="btn btn-icon btn-sm"
                  ><i class="ti ti-eye"></i
                ></a>
                <!-- <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                  ><i class="ti ti-edit"></i
                ></a> -->
              </div>
            </div>
          </div>
          <div
            class="p-3"
            *ngIf="
              business.referenceIdInstagram ||
              business.referenceIdTwitter ||
              business.referenceIdWhatsapp ||
              business.referenceIdLinkedIn ||
              business.referenceIdFacebook
            "
          >
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6>Social Links</h6>
              <!-- <a href="javascript:void(0);" class="btn btn-icon btn-sm"><i class="ti ti-edit"></i></a> -->
            </div>
            <div class="d-flex align-items-center mb-3">
              <a
                href="{{ business.referenceIdInstagram }}"
                class="me-2"
                *ngIf="business.referenceIdInstagram"
                ><img src="assets/img/social/social-01.svg" alt="Img"
              /></a>
              <a
                href="{{ business.referenceIdTwitter }}"
                class="me-2"
                *ngIf="business.referenceIdTwitter"
                ><img src="assets/img/social/social-06.svg" alt="Img"
              /></a>
              <a
                href="{{ business.referenceIdWhatsapp }}"
                class="me-2"
                *ngIf="business.referenceIdWhatsapp"
                ><img src="assets/img/social/social-02.svg" alt="Img"
              /></a>
              <!-- <a href="javascript:void(0);" class="me-2"><img src="assets/img/social/social-03.svg" alt="Img"></a> -->
              <a
                href="{{ business.referenceIdLinkedIn }}"
                class="me-2"
                *ngIf="business.referenceIdLinkedIn"
                ><img src="assets/img/social/social-04.svg" alt="Img"
              /></a>
              <a
                href="{{ business.referenceIdFacebook }}"
                class="me-2"
                *ngIf="business.referenceIdFacebook"
                ><img src="assets/img/social/social-05.svg" alt="Img"
              /></a>
            </div>
            <div class="row gx-2 d-none">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="d-flex align-items-center justify-content-center btn btn-dark"
                >
                  <i class="ti ti-share-2 me-2"></i>Share
                </a>
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="d-flex align-items-center justify-content-center btn btn-primary"
                >
                  <i class="ti ti-trash me-2"></i>Delete
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-8">
      <div>
        <div class="bg-white rounded">
          <ul class="nav nav-tabs nav-tabs-bottom nav-justified flex-wrap mb-3" role="tablist">
            <li class="nav-item" role="presentation" *appHasPermission="[{ employees: ['view'] }]">
              <a
                class="nav-link active fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab6"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-users me-1"></i>
                Employees
              </a>
            </li>
            <li class="nav-item" role="presentation" *appHasPermission="{ employees: ['view'] }">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab7"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-users me-1"></i>
                Business Owners
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#basic-info-tasklogs"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
                (click)="onLogsTabClick()"
              >
                <!-- <i class="ti ti-users me-1"></i> -->
                Logs
              </a>
              <!-- <button
                class="nav-link"
                id="info-tab-tasklogs"
                data-bs-toggle="tab"
                data-bs-target="#basic-info-tasklogs"
                role="tab"
                aria-selected="true"
              >
                Logs
              </button> -->
            </li>
            <li class="nav-item d-none" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab1"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-activity me-1"></i>
                Activities <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item d-none" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab2"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-file-description me-1"></i>
                Notes <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item d-none" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab3"
                data-bs-toggle="tab"
                aria-selected="true"
                role="tab"
              >
                <i class="ti ti-phone-call me-1"></i>
                Calls <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item d-none" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab4"
                data-bs-toggle="tab"
                aria-selected="true"
                role="tab"
              >
                <i class="ti ti-files me-1"></i>
                Files <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item d-none" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab5"
                data-bs-toggle="tab"
                aria-selected="true"
                role="tab"
              >
                <i class="ti ti-mail-check me-1"></i>
                Email <span class="text-danger">*</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-content">
          <div
            class="tab-pane active show"
            id="bottom-justified-tab6"
            role="tabpanel"
            *appHasPermission="[{ employees: ['view'] }]"
          >
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                  <h5>Employees</h5>
                  <div
                    class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
                  >
                    <!-- <div class="me-3" *ngIf="employees$ | async as employees">
                      <select
                        class="form-select form-select-sm col-md-1"
                        id="entries"
                        [(ngModel)]="pageLimit"
                        (change)="onPageLimitChange()"
                      >
                        <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
                          {{ limit }}
                        </option>
                      </select>
                    </div> -->

                    <div class="dropdown me-3">
                      <select
                        class="form-select"
                        #statusSelect
                        [(ngModel)]="status"
                        (change)="statusChange()"
                      >
                        <option value="" selected>Select Status</option>
                        <option value="false">Active</option>
                        <option value="true">Inactive</option>
                      </select>
                    </div>

                    <div class="form-sort">
                      <label>
                        <input
                          type="search"
                          [(ngModel)]="search"
                          [ngModelOptions]="{ standalone: true }"
                          (input)="statusChange()"
                          class="form-control"
                          placeholder="Search"
                      /></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body p-0 mt-1">
                <div class="custom-datatable-filter table-responsive">
                  <ng-container *ngIf="employees$ | async as employees">
                    <table class="table datatable" *ngIf="employees.length > 0; else noRecords">
                      <thead class="thead-light">
                        <tr>
                          <th>Name</th>
                          <th>Contact</th>
                          <!-- <th>Mobile</th> -->
                          <th>Office</th>
                          <!-- <th>Business Entity</th>
                          <th>Owner</th> -->
                          <th>Employment Type</th>
                          <!-- <th class="text-end">Action</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let employee of employees$ | async">
                          <td>
                            <div class="d-flex align-items-center">
                              <a
                                [routerLink]="['/hrm/employee', employee.id]"
                                class="avatar avatar-md position-relative"
                                style="height: 35px; width: 40px"
                              >
                                <!-- <img
                                  [src]="
                                    employee.picture ? businessImages[employee.picture] : defaultImg
                                  "
                                  class="img-fluid rounded-circle"
                                  alt="img"
                                /> -->
                                <!-- <ng-container
                                  *ngIf="
                                    employee.picture && businessImages[employee.picture];
                                    else initials
                                  "
                                >
                                  <img
                                    [src]="businessImages[employee.picture]"
                                    (error)="onImageError(employee)"
                                    class="img-fluid rounded-circle"
                                    alt="img"
                                    style="width: 100%; height: 100%; object-fit: cover"
                                  />
                                </ng-container>

                                <ng-template #initials>
                                  <span
                                    class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                    style="width: 30px; height: 30px"
                                    >{{ getInitials(employee.firstName, employee.lastName) }}</span
                                  >
                                </ng-template> -->

                                <ng-container
                                  *ngIf="
                                    employee.picture && businessImages[employee.picture];
                                    else initials
                                  "
                                >
                                  <span
                                    class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center text-white"
                                    style="width: 100%; height: 100%; object-fit: cover"
                                    [ngClass]="employee.disabled ? 'offline' : 'online'"
                                  >
                                    <img
                                      [src]="businessImages[employee.picture]"
                                      (error)="onImageError(employee)"
                                      alt="Img"
                                      class="img-fluid rounded-circle w-100 h-100 object-fit-cover"
                                  /></span>
                                </ng-container>
                                <ng-template #initials>
                                  <span
                                    class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                    style="width: 100%; height: 100%; object-fit: cover"
                                    [ngClass]="employee.disabled ? 'offline' : 'online'"
                                  >
                                    {{ getInitials(employee.firstName, employee.lastName) }}
                                  </span>
                                </ng-template>
                              </a>
                              <div class="ms-2">
                                <p class="text-dark mb-0">
                                  <a [routerLink]="['/hrm/employee', employee.id]"
                                    >{{ employee.firstName | capitalize }}
                                    {{ employee.lastName | capitalize }}</a
                                  >
                                </p>
                                <span class="fs-12">{{
                                  employee.designation?.designationName | capitalize
                                }}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <a
                              href="mailto:{{ employee.email }}"
                              class="__cf_email__"
                              data-cfemail="4a3825282f383e3925240a2f322b273a262f64292527"
                              >{{ employee.email }}</a
                            ><br />{{ employee.mobile }}
                          </td>
                          <!-- <td>{{ employee.mobile }}</td> -->
                          <td>{{ employee.office?.officeName | capitalize }}</td>
                          <!-- <td>{{ employee.business?.businessName | capitalize }}</td>
                          <td>
                            {{ employee.business?.user?.firstName | capitalize }}
                            {{ employee.business?.user?.lastName | capitalize }}
                          </td> -->
                          <td>
                            <!-- <span
                              *ngIf="!employee.disabled"
                              class="badge badge-success d-inline-flex align-items-center badge-xs"
                            >
                              <i class="ti ti-point-filled me-1"></i>Active
                            </span>
                            <span
                              *ngIf="employee.disabled"
                              class="badge badge-danger d-inline-flex align-items-center badge-xs"
                            >
                              <i class="ti ti-point-filled me-1"></i>Inactive
                            </span> -->
                            <!-- {{ employee.role ?? '' }} -->
                            {{ employee.employmentType ?? '' }}
                          </td>
                          <!-- <td class="text-end">
                            <div class="action-icon d-inline-flex">
                              <a
                                [routerLink]="['/hrm/employee', employee.id]"
                                class="me-2"
                                *appHasPermission="{ user: ['view'] }"
                                ><i class="ti ti-eye"></i
                              ></a>
                            </div>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <ng-template #noRecords>
                    <div class="text-center">Record not available</div>
                  </ng-template>
                </div>
              </div>
              <!-- pagination -->
              <ng-container *ngIf="employees$ | async as employees">
                <div
                  class="d-flex align-items-center justify-content-between ms-2"
                  *ngIf="employees.length > 0"
                >
                  <div>
                    Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                    {{ totalCount }} entries
                  </div>
                  <div class="has-text-centered mt-3">
                    <app-pagination
                      [currentPage]="currentPage"
                      [pageSize]="pageLimit"
                      [totalRows]="totalCount"
                      (pageChange)="onPageChange($event)"
                    ></app-pagination>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div
            class="tab-pane"
            id="bottom-justified-tab7"
            role="tabpanel"
            *appHasPermission="{ employees: ['view'] }"
          >
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                  <h5>Business Owners</h5>
                </div>
              </div>
              <div class="card-body p-0 mt-1">
                <div class="custom-datatable-filter table-responsive">
                  <ng-container *ngIf="businessOwners$ | async as owners">
                    <table class="table datatable" *ngIf="owners.length > 0; else noOwnerRecords">
                      <thead class="thead-light">
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <!-- <th>Office</th>
                          <th>Business Entity</th>
                          <th>Owner</th> -->
                          <th>Status</th>
                          <!-- <th class="text-end">Action</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let employee of businessOwners$ | async">
                          <td>
                            <div class="d-flex align-items-center">
                              <a
                                [routerLink]="['/hrm/employee', employee.id]"
                                class="avatar avatar-md"
                              >
                                <!-- <img
                                  [src]="
                                    employee.picture ? businessImages[employee.picture] : defaultImg
                                  "
                                  class="img-fluid rounded-circle"
                                  alt="img"
                                /> -->
                                <ng-container
                                  *ngIf="
                                    employee.picture && businessImages[employee.picture];
                                    else initials
                                  "
                                >
                                  <img
                                    [src]="businessImages[employee.picture]"
                                    (error)="onImageError(employee)"
                                    class="img-fluid rounded-circle"
                                    alt="img"
                                    style="width: 100%; height: 100%; object-fit: cover"
                                  />
                                </ng-container>

                                <ng-template #initials>
                                  <span
                                    class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                    style="width: 30px; height: 30px"
                                    >{{ getInitials(employee.firstName, employee.lastName) }}</span
                                  >
                                </ng-template>
                              </a>
                              <div class="ms-2">
                                <p class="text-dark mb-0">
                                  <a [routerLink]="['/hrm/employee', employee.id]"
                                    >{{ employee.firstName | capitalize }}
                                    {{ employee.lastName | capitalize }}</a
                                  >
                                </p>
                                <span class="fs-12">{{
                                  employee.designation?.designationName | capitalize
                                }}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <a
                              href="mailto:{{ employee.email }}"
                              class="__cf_email__"
                              data-cfemail="4a3825282f383e3925240a2f322b273a262f64292527"
                              >{{ employee.email }}</a
                            >
                          </td>
                          <td>{{ employee.mobile }}</td>
                          <!-- <td>{{ employee.office?.officeName | capitalize }}</td>
                          <td>{{ employee.business?.businessName | capitalize }}</td>
                          <td>
                            {{ employee.business?.user?.firstName | capitalize }}
                            {{ employee.business?.user?.lastName | capitalize }}
                          </td> -->
                          <td>
                            <span
                              *ngIf="!employee.disabled"
                              class="badge badge-success d-inline-flex align-items-center badge-xs"
                            >
                              <i class="ti ti-point-filled me-1"></i>Active
                            </span>
                            <span
                              *ngIf="employee.disabled"
                              class="badge badge-danger d-inline-flex align-items-center badge-xs"
                            >
                              <i class="ti ti-point-filled me-1"></i>Inactive
                            </span>
                          </td>
                          <!-- <td class="text-end">
                            <div class="action-icon d-inline-flex">
                              <a
                                [routerLink]="['/hrm/employee', employee.id]"
                                class="me-2"
                                *appHasPermission="{ user: ['view'] }"
                                ><i class="ti ti-eye"></i
                              ></a>
                            </div>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <ng-template #noOwnerRecords>
                    <div class="text-center">Record not available</div>
                  </ng-template>
                </div>
              </div>
              <!-- pagination -->
              <!-- <ng-container *ngIf="employees$ | async as employees">
                <div
                  class="d-flex align-items-center justify-content-between ms-2"
                  *ngIf="employees.length > 0"
                >
                  <div>
                    Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                    {{ totalCount }} entries
                  </div>
                  <div class="has-text-centered mt-3">
                    <app-pagination
                      [currentPage]="currentPage"
                      [pageSize]="pageLimit"
                      [totalRows]="totalCount"
                      (pageChange)="onPageChange($event)"
                    ></app-pagination>
                  </div>
                </div>
              </ng-container> -->
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="basic-info-tasklogs"
            role="tabpanel"
            aria-labelledby="info-tab-tasklogs"
            tabindex="0"
          >
            <div class="row">
              <ng-container *ngIf="tasklogs$ | async as tasklogs">
                <div class="col-md-12 d-flex">
                  <div class="card flex-fill">
                    <div class="card-header">
                      <div class="d-flex align-items-center justify-content-between">
                        <h5>Business Logs</h5>
                        <div
                          class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
                        >
                          <div class="form-sort">
                            <label>
                              <input
                                type="search"
                                [formControl]="logSearchQuery"
                                class="form-control"
                                placeholder="Search"
                            /></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body p-0 mt-1">
                      <div class="custom-datatable-filter table-responsive">
                        <ng-container *ngIf="tasklogs">
                          <table
                            class="table datatable"
                            *ngIf="tasklogs.length > 0; else noTasklogRecords"
                          >
                            <thead class="thead-light">
                              <tr>
                                <th>Action</th>
                                <th>Date Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="user$ | async as currentUser">
                                <tr *ngFor="let tasklog of tasklogs">
                                  <td>
                                    <span class="text-wrap d-inline-block">
                                      <ng-container
                                        *ngFor="
                                          let segment of tasklog | generateLogMessage: currentUser
                                        "
                                      >
                                        <a
                                          class="text-primary"
                                          *ngIf="segment.link"
                                          [routerLink]="segment.link"
                                          >{{ segment.text }}</a
                                        >
                                        <!-- If the segment has NO link, render plain text -->
                                        <ng-container *ngIf="!segment.link">{{
                                          segment.text
                                        }}</ng-container>
                                      </ng-container>
                                    </span>
                                  </td>
                                  <td>
                                    {{ tasklog.createdAt | date: 'medium' }}
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </ng-container>
                        <ng-template #noTasklogRecords>
                          <div class="mb-3">
                            <div class="d-flex align-items-center justify-content-between">
                              Record not available.
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <!-- pagination -->
                    <ng-container *ngIf="tasklogs$ | async as tasklog">
                      <div
                        class="d-flex align-items-center justify-content-between ms-2"
                        *ngIf="tasklog.length > 0 && totalTasklogCount > 0"
                      >
                        <div>
                          Showing
                          {{ ((currentTasklogPage || 1) - 1) * (pageLimit || 10) + 1 }}
                          to
                          {{ pageTasklogLastRecord }} of {{ totalTasklogCount }} entries
                        </div>
                        <div class="has-text-centered mt-3">
                          <app-pagination
                            [currentPage]="currentTasklogPage"
                            [pageSize]="pageLimit"
                            [totalRows]="totalTasklogCount"
                            (pageChange)="onTasklogPageChange($event)"
                          ></app-pagination>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- permission set -->
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab1" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                  <h5>Activities</h5>
                  <div class="dropdown">
                    <a
                      href="javascript:void(0);"
                      class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1"
                          >Recently Added</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">Ascending</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">Desending</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">Last Month</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1"
                          >Last 7 Days</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <span class="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                  <i class="ti ti-calendar me-1"></i>
                  15 Feb 2024
                </span>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-skyblue me-2"
                      ><i class="ti ti-message-circle-2 fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">You sent 1 Message to the contact.</h6>
                      <span>10:25 pm</span>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded bg-success flex-shrink-0 me-2"
                      ><i class="ti ti-phone fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">
                        Denwar responded to your appointment schedule question by call at 09:30pm.
                      </h6>
                      <span>09:25 pm</span>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-warning me-2"
                      ><i class="ti ti-file-description fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">Notes added by Antony</h6>
                      <p class="mb-1">
                        Please accept my apologies for the inconvenience caused. It would be much
                        appreciated if it's possible to reschedule to 6:00 PM, or any other day that
                        week.
                      </p>
                      <span>10.00 pm</span>
                    </div>
                  </div>
                </div>
                <span class="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                  <i class="ti ti-calendar me-1"></i>
                  15 Feb 2024
                </span>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-purple me-2"
                      ><i class="ti ti-user-circle fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium d-flex align-items-center mb-1">
                        Meeting With
                        <span class="avatar avatar-sm avatar-rounded mx-1"
                          ><img src="assets/img/profiles/avatar-02.jpg" alt="Img"
                        /></span>
                        Abraham
                      </h6>
                      <span>Schedueled on 05:00 pm</span>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded bg-success flex-shrink-0 me-2"
                      ><i class="ti ti-phone fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">
                        Drain responded to your appointment schedule question.
                      </h6>
                      <span>09:25 pm</span>
                    </div>
                  </div>
                </div>
                <span class="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                  <i class="ti ti-calendar me-1"></i>
                  Upcoming Activity
                </span>
                <div class="border rounded p-3">
                  <div class="d-flex align-items-start mb-2">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-purple me-2"
                      ><i class="ti ti-user-circle fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">Product Meeting</h6>
                      <p class="mb-1">
                        A product team meeting is a gathering of the cross-functional product team —
                        ideally including team members from product, engineering, marketing, and
                        customer support.
                      </p>
                      <span>Schedueled on 05:00 pm</span>
                    </div>
                  </div>
                  <div class="bg-light-500 rounded p-3">
                    <div class="row">
                      <div class="col-md-4 col-sm-6">
                        <div>
                          <h6 class="fs-12 fw-medium mb-2">Reminder</h6>
                          <div class="dropdown">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              <i class="clock-hour-3 me-1"></i>
                              Reminder
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >Reminder</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >1 Hr</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >10 Hr</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-6">
                        <div>
                          <h6 class="fs-12 fw-medium mb-2">Task Priority</h6>
                          <div class="dropdown">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-toggle btn-sm btn btn-white d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              <span
                                class="border border-purple rounded-circle bg-soft-danger d-flex justify-content-center align-items-center me-1"
                              >
                                <i class="ti ti-point-filled text-danger"></i>
                              </span>
                              High
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >High</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >Medium</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >Low</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-6">
                        <div>
                          <h6 class="fs-12 fw-medium mb-2">Assigned to</h6>
                          <div class="dropdown">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              <span class="avatar avatar-xs avatar-rounded me-1">
                                <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                              </span>
                              John
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center"
                                >
                                  <span class="avatar avatar-xs avatar-rounded me-1">
                                    <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                                  </span>
                                  John
                                </a>
                              </li>
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center"
                                >
                                  <span class="avatar avatar-xs avatar-rounded me-1">
                                    <img src="assets/img/profiles/avatar-01.jpg" alt="Img" />
                                  </span>
                                  Sophie
                                </a>
                              </li>
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center"
                                >
                                  <span class="avatar avatar-xs avatar-rounded me-1">
                                    <img src="assets/img/profiles/avatar-03.jpg" alt="Img" />
                                  </span>
                                  Estelle
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab2" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Notes</h5>
                  <div class="d-flex align-items-center">
                    <div class="dropdown me-2">
                      <a
                        href="javascript:void(0);"
                        class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        Sort By : Last 7 Days
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Recently Added</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Ascending</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Desending</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Last Month</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Last 7 Days</a
                          >
                        </li>
                      </ul>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="d-inline-flex align-items-center text-primary fw-medium"
                      data-bs-toggle="modal"
                      data-bs-target="#add_notes"
                    >
                      <i class="ti ti-circle-plus me-1"></i>
                      Add Note
                    </a>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                      </span>
                      <div>
                        <h6 class="fw-medium mb-1">Darlee Robertson</h6>
                        <span>15 Sep 2023, 12:10 pm</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <h6 class="fw-medium mb-2">Notes added by Antony</h6>
                    <p class="mb-3">
                      A project review evaluates the success of an initiative and identifies areas
                      for improvement. It can also evaluate a current project to determine whether
                      it's on the right track. Or, it can determine the success of a completed
                      project.
                    </p>
                    <div class="d-flex align-items-center flex-wrap gap-3 mb-3">
                      <div
                        class="border rounded d-flex align-items-center justify-content-between hover-border p-3"
                      >
                        <div class="d-flex align-items-center me-4">
                          <span
                            class="avatar avatar-lg bg-success avatar-rounded flex-shrink-0 me-2"
                          >
                            <i class="ti ti-file-type-xls fs-24"></i>
                          </span>
                          <div>
                            <h6 class="fw-medium">Project Specs.xls</h6>
                            <span>365 KB</span>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-16"
                          ><i class="ti ti-download"></i
                        ></a>
                      </div>
                      <div
                        class="border rounded d-flex align-items-center justify-content-between hover-border p-3"
                      >
                        <div class="d-flex align-items-center me-4">
                          <span
                            class="avatar avatar-lg bg-success avatar-rounded flex-shrink-0 me-2"
                          >
                            <i class="ti ti-file-type-xls fs-24"></i>
                          </span>
                          <div>
                            <h6 class="fw-medium">090224.jpg</h6>
                            <span>365 KB</span>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-16"
                          ><i class="ti ti-download"></i
                        ></a>
                      </div>
                    </div>
                    <div class="notes-editor">
                      <div class="note-edit-wrap">
                        <div class="mb-3">
                          <div class="summernote">
                            Write a new comment, send your team notification by typing &#64;
                            followed by their name
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mb-3">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-outline-light border add-cancel me-3"
                            >Cancel</a
                          >
                          <a href="javascript:void(0);" class="btn btn-primary">Save</a>
                        </div>
                      </div>
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center justify-content-end text-primary fw-medium add-comment"
                        >
                          <i class="ti ti-circle-plus me-1"></i>
                          Add Comment
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <h6 class="fw-medium mb-1">Sharon Roy</h6>
                        <span>18 Sep 2023, 09:52 am</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <h6 class="fw-medium mb-2">Notes added by Antony</h6>
                    <p class="mb-3">
                      A project plan typically contains a list of the essential elements of a
                      project, such as stakeholders, scope, timelines, estimated cost and
                      communication methods. The project manager typically lists the information
                      based on the assignment.
                    </p>
                    <div class="d-flex align-items-center flex-wrap gap-3 mb-3">
                      <div
                        class="border rounded d-flex align-items-center justify-content-between hover-border p-3"
                      >
                        <div class="d-flex align-items-center me-4">
                          <span
                            class="avatar avatar-lg bg-purple avatar-rounded flex-shrink-0 me-2"
                          >
                            <i class="ti ti-file-description fs-24"></i>
                          </span>
                          <div>
                            <h6 class="fw-medium">Andrewpass.txt</h6>
                            <span>365 KB</span>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-16"
                          ><i class="ti ti-download"></i
                        ></a>
                      </div>
                    </div>
                    <div class="bg-light-500 rounded p-3 mb-3">
                      <p class="mb-2">
                        The best way to get a project done faster is to start sooner. A goal without
                        a timeline is just a dream.The goal you set must be challenging. At the same
                        time, it should be realistic and attainable, not impossible to reach.
                      </p>
                      <p class="text-dark mb-2">
                        Commented by <span class="text-primary"> Aeron</span> on 15 Sep 2023, 11:15
                        pm
                      </p>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-dark d-inline-flex align-items-center"
                        ><i class="ti ti-arrow-back-up me-1"></i>Reply</a
                      >
                    </div>
                    <div class="notes-editor">
                      <div class="note-edit-wrap">
                        <div class="mb-3">
                          <div class="summernote">
                            Write a new comment, send your team notification by typing &#64;
                            followed by their name
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mb-3">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-outline-light border add-cancel me-3"
                            >Cancel</a
                          >
                          <a href="javascript:void(0);" class="btn btn-primary">Save</a>
                        </div>
                      </div>
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center justify-content-end text-primary fw-medium add-comment"
                        >
                          <i class="ti ti-circle-plus me-1"></i>
                          Add Comment
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <h6 class="fw-medium mb-1">Vaughan Lewis</h6>
                        <span>20 Sep 2023, 10:26 pm</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <h6 class="fw-medium mb-2">Notes added by Antony</h6>
                    <p class="mb-3">
                      Projects play a crucial role in the success of organizations, and their
                      importance cannot be overstated. Whether it's launching a new product,
                      improving an existing
                    </p>
                    <div class="notes-editor">
                      <div class="note-edit-wrap">
                        <div class="mb-3">
                          <div class="summernote">
                            Write a new comment, send your team notification by typing &#64;
                            followed by their name
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mb-3">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-outline-light border add-cancel me-3"
                            >Cancel</a
                          >
                          <a href="javascript:void(0);" class="btn btn-primary">Save</a>
                        </div>
                      </div>
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center justify-content-end text-primary fw-medium add-comment"
                        >
                          <i class="ti ti-circle-plus me-1"></i>
                          Add Comment
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab3" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Calls</h5>
                  <a
                    href="javascript:void(0);"
                    class="d-inline-flex align-items-center text-primary fw-medium"
                    data-bs-toggle="modal"
                    data-bs-target="#add_call"
                  >
                    <i class="ti ti-circle-plus me-1"></i>
                    Add New
                  </a>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                      </span>
                      <div>
                        <p class="fw-medium">
                          <span class="text-dark">Darlee Robertson </span> logged a call on 23 Jul
                          2023, 10:00 pm
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="dropdown me-2">
                        <a
                          href="#"
                          class="dropdown-toggle btn btn-sm bg-danger-transparent border-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          >Busy<i class="las la-angle-down ms-1"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-end p-3">
                          <a class="dropdown-item rounded-1" href="javascript:void(0);">Busy</a>
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >No Answer</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Unavailable</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Wrong Number</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Left Voice Message</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Moving Forward</a
                          >
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <p>
                      A project review evaluates the success of an initiative and identifies areas
                      for improvement. It can also evaluate a current project to determine whether
                      it's on the right track. Or, it can determine the success of a completed
                      project
                    </p>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <p class="fw-medium">
                          <span class="text-dark">Sharon Roy </span> logged a call on 28 Jul 2023,
                          09:00 pm
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="dropdown me-2">
                        <a
                          href="#"
                          class="dropdown-toggle btn btn-sm bg-transparent-purple border-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          >No Answer<i class="las la-angle-down ms-1"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-end p-3">
                          <a class="dropdown-item rounded-1" href="javascript:void(0);">Busy</a>
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >No Answer</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Unavailable</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Wrong Number</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Left Voice Message</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Moving Forward</a
                          >
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <p>
                      A project plan typically contains a list of the essential elements of a
                      project, such as stakeholders, scope, timelines, estimated cost and
                      communication methods. The project manager typically lists the information
                      based on the assignment.
                    </p>
                  </div>
                </div>
                <div class="border rounded p-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <p class="fw-medium">
                          <span class="text-dark">Vaughan Lewis </span> logged a call on 30 Jul
                          2023, 08:00 pm
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="dropdown me-2">
                        <a
                          href="#"
                          class="dropdown-toggle btn btn-sm bg-transparent-purple border-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          >No Answer<i class="las la-angle-down ms-1"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-end p-3">
                          <a class="dropdown-item rounded-1" href="javascript:void(0);">Busy</a>
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >No Answer</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Unavailable</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Wrong Number</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Left Voice Message</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Moving Forward</a
                          >
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <p>
                      Projects play a crucial role in the success of organizations, and their
                      importance cannot be overstated. Whether it's launching a new product,
                      improving an existing
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab4" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Files</h5>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Manage Documents</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div>
                      <a
                        href="#"
                        class="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#create_file"
                        >Create Document</a
                      >
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-2"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Collier-Turner Proposal</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-download"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                      </span>
                      <div>
                        <span class="d-inline-flex mb-1">Owner</span>
                        <h6 class="fw-medium">Darlee Robertson</h6>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="badge bg-pink-transparent me-2">Proposal</span>
                      <span class="badge badge-dark-transparent"
                        ><i class="ti ti-point-filled"></i>Proposal</span
                      >
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-2"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Collier-Turner Proposal</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-download"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-01.jpg" alt="Img" />
                      </span>
                      <div>
                        <span class="d-inline-flex mb-1">Owner</span>
                        <h6 class="fw-medium">Sharon Roy</h6>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="badge badge-soft-info me-2">Quote</span>
                      <span class="badge badge-soft-success"
                        ><i class="ti ti-point-filled"></i>Sent</span
                      >
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-2"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Collier-Turner Proposal</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-download"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <span class="d-inline-flex mb-1">Owner</span>
                        <h6 class="fw-medium">Vaughan Lewis</h6>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="badge bg-pink-transparent me-2">Proposal</span>
                      <span class="badge badge-dark-transparent"
                        ><i class="ti ti-point-filled"></i>Proposal</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab5" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Email</h5>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Manage Emails</h6>
                      <p>You can send and reply to emails directly via this section.</p>
                    </div>
                    <div>
                      <a
                        href="#"
                        class="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#connect_account"
                        >Connect Account</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- employee listing tab -->
      </div>
    </div>
  </div>
</div>

<ng-template #addBusinessModals let-modal *ngIf="business$ | async as business">
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Update Business Entity</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 1" >Owner Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 2"  >Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Address</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 3"  >Address</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Social Profiles</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="form" autocomplete="off" enctype="multipart/form-data">
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 1, 'd-none': currentStep !== 1 }"
          id="business-details"
          role="tabpanel"
          aria-labelledby="business-details-tab"
          tabindex="0"
        >
          <!-- <div class="mb-4">
          <h5>Enter Business Owner Details</h5>
        </div> -->
          <fieldset
            *ngIf="currentStep === 1"
            id="first-field"
            formGroupName="businessInfoForm"
            [ngClass]="{ 'display-block': currentStep === 1, 'display-none': currentStep !== 1 }"
          >
            <div class="col-md-12">
              <div
                class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
              >
                <div
                  class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
                >
                  <i class="ti ti-photo text-gray-2 fs-16" *ngIf="!imageURL"></i>
                  <!-- <span> -->
                  <!-- <img
                      [src]="businessImages[business.picture] || imageURL"
                      alt="Img"
                      class="img-fluid rounded-circle"
                    /> -->
                  <img
                    [src]="imageURL"
                    alt="Img"
                    *ngIf="imageURL"
                    class="rounded-circle"
                    style="width: 100%; height: 100%; object-fit: cover"
                  />
                  <!-- </span> -->
                </div>
                <div class="profile-upload">
                  <div class="mb-2">
                    <h6 class="mb-1">Upload Logo</h6>
                    <!-- <p class="fs-12">Image should be below 4 mb</p> -->
                  </div>
                  <div class="profile-uploader d-flex align-items-center">
                    <div class="drag-upload-btn btn btn-sm btn-primary me-2">
                      Upload
                      <input
                        type="file"
                        name="picture"
                        class="form-control image-sign"
                        (change)="onFileChange($event, 'imageURL')"
                        accept="image/jpeg, image/png, image/gif, image/bmp, image/webp"
                      />
                    </div>
                    <!-- <a href="javascript:void(0);" class="btn btn-light btn-sm">Cancel</a> -->
                  </div>
                </div>
                <div
                  *ngIf="
                    form.get('businessInfoForm')?.get('picture')?.invalid &&
                    form.get('businessInfoForm')?.get('picture')?.touched
                  "
                >
                  <span class="text-danger">
                    {{ getErrorMessage('businessInfoForm.picture') }}
                  </span>
                </div>
              </div>
            </div>
            <div class="contact-input-set">
              <div class="row">
                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="businessName"
                      >Business Name <span class="text-danger"> *</span></label
                    >
                    <input formControlName="businessName" class="form-control" appTrimInput />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('businessName')?.invalid &&
                        form.get('businessInfoForm')?.get('businessName')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.businessName') }}
                      </span>
                    </div>
                    <!-- Other fields for Basic Info here -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="website"
                      >Website <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="website"
                      appTrimInput
                      type="url"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('website')?.invalid &&
                        form.get('businessInfoForm')?.get('website')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.website') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="incorporationDate"
                      >Incorporation Date <span class="text-danger"> *</span></label
                    >
                    <input
                      type="date"
                      formControlName="incorporationDate"
                      [max]="today | date: 'yyyy-MM-dd'"
                      appTrimInput
                      class="form-control"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('incorporationDate')?.invalid &&
                        form.get('businessInfoForm')?.get('incorporationDate')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.incorporationDate') }}
                      </span>
                    </div>
                    <!-- Other fields for Basic Info here -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="incorporationNo"
                      >Incorporation Number <span class="text-danger"> *</span></label
                    >
                    <input formControlName="incorporationNo" class="form-control" appTrimInput />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('incorporationNo')?.invalid &&
                        form.get('businessInfoForm')?.get('incorporationNo')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.businesincorporationNosName') }}
                      </span>
                    </div>
                    <!-- Other fields for Basic Info here -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="PAN"
                      >PAN <span class="text-danger"> *</span></label
                    >
                    <input formControlName="PAN" class="form-control" appTrimInput />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('PAN')?.invalid &&
                        form.get('businessInfoForm')?.get('PAN')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.PAN') }}
                      </span>
                    </div>
                    <!-- Other fields for Basic Info here -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="GST"
                      >GST <span class="text-danger"> *</span></label
                    >
                    <input formControlName="GST" class="form-control" appTrimInput />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('GST')?.invalid &&
                        form.get('businessInfoForm')?.get('GST')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.GST') }}
                      </span>
                    </div>
                    <!-- Other fields for Basic Info here -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="empidprefix"
                      >Employee ID Format <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="empidprefix"
                      appTrimInput
                      type="text"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('empidprefix')?.invalid &&
                        form.get('businessInfoForm')?.get('empidprefix')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.empidprefix') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="empidprefixStart"
                      >Employee ID Prefix Start Number <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="empidprefixStart"
                      appTrimInput
                      type="text"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('empidprefixStart')?.invalid &&
                        form.get('businessInfoForm')?.get('empidprefixStart')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.empidprefixStart') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="contractoridprefix"
                      >Contractor ID Format <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="contractoridprefix"
                      appTrimInput
                      type="text"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('contractoridprefix')?.invalid &&
                        form.get('businessInfoForm')?.get('contractoridprefix')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.contractoridprefix') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="contractoridprefixStart"
                      >Contractor ID Prefix Start Number <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="contractoridprefixStart"
                      appTrimInput
                      type="text"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('contractoridprefixStart')?.invalid &&
                        form.get('businessInfoForm')?.get('contractoridprefixStart')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.contractoridprefixStart') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="traineeidprefix"
                      >Trainee ID Format <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="traineeidprefix"
                      appTrimInput
                      type="text"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('traineeidprefix')?.invalid &&
                        form.get('businessInfoForm')?.get('traineeidprefix')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.traineeidprefix') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="traineeidprefixStart"
                      >Trainee ID Prefix Start Number <span class="text-danger"> *</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      formControlName="traineeidprefixStart"
                      appTrimInput
                      type="text"
                    />
                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('traineeidprefixStart')?.invalid &&
                        form.get('businessInfoForm')?.get('traineeidprefixStart')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.traineeidprefixStart') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="currencyId"
                      >Currency <span class="text-danger">*</span></label
                    >
                    <select
                      class="form-select"
                      id="currencyId"
                      formControlName="currencyId"
                      appTrimInput
                    >
                      <option selected value="">Select Currency</option>
                      <option *ngFor="let country of countries$ | async" [ngValue]="country.id">
                        {{ country.currency_name }}
                      </option>
                      <!-- <option>US</option> -->
                    </select>

                    <div
                      *ngIf="
                        form.get('businessInfoForm')?.get('currencyId')?.invalid &&
                        form.get('businessInfoForm')?.get('currencyId')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('businessInfoForm.currencyId') }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- <ng-container *ngIf="(user$ | async)?.role === 'Admin'"> -->
                <ng-container *ngIf="hasAdminRole(user$ | async)">
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="userId">Primary Owner </label>
                      <ng-select
                        class="mb-3"
                        [items]="users$ | async"
                        bindValue="id"
                        formControlName="userId"
                        appTrimInput
                        [searchable]="true"
                        [clearable]="true"
                        [searchFn]="customSearchFn"
                        placeholder="Select Business Entity Owner"
                        [ngClass]="{
                          'is-invalid':
                            form.get('businessInfoForm')?.get('userId')?.invalid &&
                            (form.get('businessInfoForm')?.get('userId')?.touched ||
                              assignBusinessOwnerform.get('userId')?.dirty)
                        }"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.firstName }} {{ item.lastName }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          {{ item.firstName }} {{ item.lastName }}
                        </ng-template>
                      </ng-select>

                      <div
                        *ngIf="
                          form.get('businessInfoForm')?.get('userId')?.invalid &&
                          (form.get('businessInfoForm')?.get('userId')?.touched ||
                            form.get('businessInfoForm')?.get('userId')?.dirty)
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('businessInfoForm.userId') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="col-lg-12 text-end form-wizard-button">
                  <button
                    type="button"
                    (click)="goToNextStep()"
                    [disabled]="!form.get('businessInfoForm')?.valid"
                    class="btn btn-primary wizard-next-btn"
                  >
                    Save & Next
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 2, 'd-none': currentStep !== 2 }"
          id="company-details"
          role="tabpanel"
          aria-labelledby="company-details-tab"
          tabindex="0"
        >
          <div>
            <fieldset *ngIf="currentStep === 2" formGroupName="addressInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="address">Street Address *</label>
                      <input formControlName="address" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('address')?.invalid &&
                          form.get('addressInfoForm')?.get('address')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.address') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="country_id"
                        >Country <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-select"
                        id="country_id"
                        formControlName="country_id"
                        [(ngModel)]="selectedCountryId"
                        (change)="onCountrySelect(selectedCountryId)"
                      >
                        <option selected value="">Select Country</option>
                        <option *ngFor="let country of countries$ | async" [value]="country.id">
                          {{ country.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>

                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('country_id')?.invalid &&
                          form.get('addressInfoForm')?.get('country_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.country_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="state_id"
                        >State / Province <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="state" class="form-control"> -->
                      <select
                        class="form-select"
                        id="state_id"
                        formControlName="state_id"
                        [(ngModel)]="selectedStateId"
                        (change)="onStateSelect(selectedStateId)"
                        [disabled]="!selectedCountryId"
                      >
                        <option selected value="">Select State</option>
                        <option *ngFor="let state of states$ | async" [value]="state.id">
                          {{ state.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('state_id')?.invalid &&
                          form.get('addressInfoForm')?.get('state_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.state_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="cityId"
                        >City <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="city" class="form-control"> -->
                      <select
                        class="form-select"
                        for="cityId"
                        formControlName="cityId"
                        [disabled]="!selectedStateId"
                      >
                        <option selected value="">Select City</option>
                        <option *ngFor="let city of cities$ | async" [value]="city.id">
                          {{ city.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('cityId')?.invalid &&
                          form.get('addressInfoForm')?.get('cityId')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.cityId') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="zipCode"
                        >Postal Code <span class="text-danger"> *</span></label
                      >
                      <input formControlName="zipCode" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('zipCode')?.invalid &&
                          form.get('addressInfoForm')?.get('zipCode')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.zipCode') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="latitude"
                        >Latitude (ex: 28.6139) <span class="text-danger"> *</span></label
                      >
                      <input formControlName="latitude" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('latitude')?.invalid &&
                          form.get('addressInfoForm')?.get('latitude')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.latitude') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="longitude"
                        >Longitude (ex: 28.6139) <span class="text-danger"> *</span></label
                      >
                      <input formControlName="longitude" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('longitude')?.invalid &&
                          form.get('addressInfoForm')?.get('longitude')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.longitude') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label col-lg-12"
                        >Is auto clock In/Out?
                        <div class="form-check form-check-inline form-check-md form-switch me-2">
                          <label class="form-check-label mt-0">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              role="switch"
                              formControlName="isAutoClockInOut"
                              (change)="toggleIsAutoClockIn()"
                            />
                            {{ isAutoClockInOut ? 'Yes' : 'No' }}
                          </label>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div class="col-md-3" *ngIf="isAdmin()">
                    <div class="mb-3">
                      <label class="form-label col-lg-12"
                        >Is mobile App?
                        <div class="form-check form-check-inline form-check-md form-switch me-2">
                          <label class="form-check-label mt-0">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              role="switch"
                              formControlName="isMobileApp"
                              (change)="toggleIsMobileApp()"
                            />
                            {{ isMobileApp ? 'Yes' : 'No' }}
                          </label>
                        </div>
                      </label>
                    </div>
                  </div>
                  <!-- Other fields for Address here -->
                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(1)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!form.get('businessInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      (click)="goToNextStep()"
                      [disabled]="!form.get('addressInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 3, 'd-none': currentStep !== 3 }"
          id="address-detail"
          role="tabpanel"
          aria-labelledby="address-detail-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
            <h5>Address Details</h5>
          </div> -->
            <fieldset *ngIf="currentStep === 3" formGroupName="socialInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="referenceIdFacebook">Facebook</label>
                      <input
                        formControlName="referenceIdFacebook"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdFacebook')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdFacebook')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdFacebook') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="referenceIdInstagram">Instagram</label>
                      <input
                        formControlName="referenceIdInstagram"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdInstagram')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdInstagram')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdInstagram') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="referenceIdLinkedIn">LinkedIn</label>
                      <input
                        formControlName="referenceIdLinkedIn"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdLinkedIn') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="referenceIdTwitter">Twitter</label>
                      <input
                        formControlName="referenceIdTwitter"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdTwitter')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdTwitter')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdTwitter') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="referenceIdWhatsapp">Whatsapp</label>
                      <input
                        formControlName="referenceIdWhatsapp"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdWhatsapp') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(2)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!form.get('socialInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="submit"
                      (click)="onSubmit()"
                      [disabled]="!form.get('socialInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      <ng-container *ngIf="isLoading$ | async; else loading">
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submit...
                      </ng-container>
                      <ng-template #loading> Submit </ng-template>
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
      </form>
    </div>
    <!-- end tab content -->
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>

<!-- assign business owner -->
<ng-template #assingBusinessOwnerModal let-modal *ngIf="business$ | async as business">
  <!-- <div class="modal fade" id="assign_businessowner">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Change Business Entity Owner</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignBusinessOwnerform">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <!-- <div class="mb-3">
            <select #userSelect class="js-select2 form-select" formControlName="userId">
              <option value="" selected>Select Business Entity Owner</option>

              <option
                *ngFor="let assignedUser of users$ | async"
                [value]="assignedUser.id"
                [attr.data-businessUser]="assignedUser"
                [selected]="business.userId === assignedUser.id"
              >
                {{ assignedUser.firstName }} {{ assignedUser.lastName }}
              </option>
            </select>
            <div
              *ngIf="
                assignBusinessOwnerform.get('userId')?.invalid &&
                (assignBusinessOwnerform.get('userId')?.touched ||
                  assignBusinessOwnerform.get('userId')?.dirty)
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('assignBusinessOwnerform.userId') }}
              </span>
            </div>
          </div> -->
          <!-- <div class="mb-3"> -->
          <ng-select
            class="mb-3"
            [items]="users$ | async"
            bindValue="id"
            formControlName="userId"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFn"
            placeholder="Select Business Entity Owner"
            [ngClass]="{
              'is-invalid':
                assignBusinessOwnerform.get('userId')?.invalid &&
                (assignBusinessOwnerform.get('userId')?.touched ||
                  assignBusinessOwnerform.get('userId')?.dirty)
            }"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              assignBusinessOwnerform.get('userId')?.invalid &&
              (assignBusinessOwnerform.get('userId')?.touched ||
                assignBusinessOwnerform.get('userId')?.dirty)
            "
          >
            <span class="text-danger">
              {{ getErrorMessage('assignBusinessOwnerform.userId') }}
            </span>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="!assignBusinessOwnerform.valid"
        (click)="assignBusinessOwner()"
      >
        <ng-container *ngIf="isLoading$ | async; else loading">
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Change Owner...
        </ng-container>
        <ng-template #loading> Change Owner </ng-template>
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /assign business owner -->

<!-- add office -->
<ng-template #addOfficeModal let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add Office</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li class="nav-item" role="presentation" [class.active]="currentStep === 1">
          <!-- <span class="nav-link" [class.active]="currentStep === 1"  >Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li class="nav-item" role="presentation" [class.active]="currentStep === 2">
          <!-- <span class="nav-link" [class.active]="currentStep === 2"  >Address</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Address</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="officeform" autocomplete="off" enctype="multipart/form-data">
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 1, 'd-none': currentStep !== 1 }"
          id="office-details"
          role="tabpanel"
          aria-labelledby="office-details-tab"
          tabindex="0"
        >
          <div>
            <fieldset *ngIf="currentStep === 1" formGroupName="companyInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="officeName"
                        >Office Name <span class="text-danger"> *</span></label
                      >
                      <input formControlName="officeName" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          officeform.get('companyInfoForm')?.get('officeName')?.invalid &&
                          officeform.get('companyInfoForm')?.get('officeName')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('companyInfoForm.officeName') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="goToNextOfficeStep()"
                      [disabled]="!officeform.get('companyInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 2, 'd-none': currentStep !== 2 }"
          id="address-detail"
          role="tabpanel"
          aria-labelledby="address-detail-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
            <h5>Address Details</h5>
          </div> -->
            <fieldset *ngIf="currentStep === 2" formGroupName="addressInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="address" class="col-form-label"
                        >Street Address <span class="text-danger">*</span></label
                      >
                      <input formControlName="address" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('address')?.invalid &&
                          officeform.get('addressInfoForm')?.get('address')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.address') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="country_id"
                        >Country <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-select"
                        formControlName="country_id"
                        (change)="onCountryChange($event)"
                      >
                        <option selected value="">Select Country</option>
                        <option *ngFor="let country of countries$ | async" [value]="country.id">
                          {{ country.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>

                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('country_id')?.invalid &&
                          officeform.get('addressInfoForm')?.get('country_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.country_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="state_id"
                        >State / Province <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="state" class="form-control"> -->
                      <select
                        class="form-select"
                        formControlName="state_id"
                        (change)="onStateChange($event)"
                      >
                        <option selected value="">Select State</option>
                        <option *ngFor="let state of states$ | async" [value]="state.id">
                          {{ state.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('state_id')?.invalid &&
                          officeform.get('addressInfoForm')?.get('state_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.state_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="cityId"
                        >City <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="city" class="form-control"> -->
                      <select class="form-select" formControlName="cityId">
                        <option selected value="">Select City</option>
                        <option *ngFor="let city of cities$ | async" [value]="city.id">
                          {{ city.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('cityId')?.invalid &&
                          officeform.get('addressInfoForm')?.get('cityId')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.cityId') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="zipCode"
                        >Postal Code <span class="text-danger"> *</span></label
                      >
                      <input formControlName="zipCode" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('zipCode')?.invalid &&
                          officeform.get('addressInfoForm')?.get('zipCode')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.zipCode') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Other fields for Address here -->
                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(1)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!officeform.get('addressInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      [disabled]="!officeform.get('addressInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                      (click)="createOfficeAddress()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
      </form>
    </div>
    <!-- end tab content -->
  </div>
</ng-template>
<!-- add office section end -->

<!-- add employee -->
<ng-template #addEmployeeModals let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add New Employee</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <form
        *ngIf="employeeform"
        [formGroup]="employeeform"
        autocomplete="off"
        enctype="multipart/form-data"
        autocomplete="off"
      >
        <!-- Step 1 (Basic Info) -->
        <fieldset *ngIf="currentStep === 1" formGroupName="companyInfoForm" id="first-field">
          <div class="col-md-12">
            <div
              class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
            >
              <div
                class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
              >
                <i class="ti ti-photo text-gray-2 fs-16" *ngIf="!imageURL"></i>
                <span
                  ><img
                    [src]="imageURL"
                    alt="Img"
                    class="img-fluid rounded-circle"
                    *ngIf="imageURL"
                /></span>
              </div>
              <div class="profile-upload">
                <div class="mb-2">
                  <h6 class="mb-1">Upload Profile Image</h6>
                  <!-- <p class="fs-12">Image should be below 4 mb</p> -->
                </div>
                <div class="profile-uploader d-flex align-items-center">
                  <div class="drag-upload-btn btn btn-sm btn-primary me-2">
                    Upload
                    <!-- <input type="file" class="form-control image-sign" formControlName="picture"
                    (change)="showPreview($event, 'imageURL')"> -->
                    <input
                      appTrimInput
                      type="file"
                      class="form-control image-sign"
                      accept="image/jpeg, image/png, image/gif, image/svg+xml, image/webp"
                      (change)="onFileChange($event, 'imageURL')"
                    />
                  </div>
                  <!-- <a href="javascript:void(0);" class="btn btn-light btn-sm">Cancel</a> -->
                </div>
              </div>
            </div>
          </div>
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="firstName"
                    >First Name <span class="text-danger"> *</span></label
                  >
                  <input formControlName="firstName" class="form-control" appTrimInput />
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('firstName')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('firstName')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.firstName') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="lastName"
                    >Last Name <span class="text-danger"> *</span></label
                  >
                  <input formControlName="lastName" class="form-control" appTrimInput />
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('lastName')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('lastName')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.lastName') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="email"
                    >Work Email <span class="text-danger"> *</span>
                    <i
                      class="ti ti-help text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Format: dave@gmail.com"
                    ></i>
                  </label>
                  <input
                    formControlName="email"
                    appTrimInput
                    appStrictEmail
                    class="form-control"
                    type="email"
                    autocomplete="off"
                  />
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('email')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('email')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.email') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="mobile"
                    >Mobile Number<span class="text-danger"> *</span>
                    <i
                      class="ti ti-help text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Format: +91 9876543210"
                    ></i>
                  </label>
                  <input class="form-control" type="text" formControlName="mobile" appTrimInput />
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('mobile')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('mobile')?.touched
                    "
                  >
                    <span class="text-danger">
                      <ng-container
                        *ngIf="
                          employeeform
                            .get('companyInfoForm')
                            ?.get('mobile')
                            ?.hasError('required') &&
                          employeeform.get('companyInfoForm')?.get('mobile')?.value === ''
                        "
                      >
                        Mobile number is required.
                      </ng-container>
                      <ng-container
                        *ngIf="
                          form
                            .get('companyInfoForm')
                            ?.get('mobile')
                            ?.hasError('invalidMobileNumber') &&
                          employeeform.get('companyInfoForm')?.get('mobile')?.value !== ''
                        "
                      >
                        Invalid mobile number format. Please use +XX XXXXXXXXXX.
                      </ng-container>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="joiningDate"
                    >Date of Joining <span class="text-danger"> *</span></label
                  >
                  <input
                    class="form-control"
                    type="date"
                    formControlName="joiningDate"
                    appTrimInput
                    [max]="todayplussixmonths | date: 'yyyy-MM-dd'"
                    [min]="(business$ | async)?.incorporationDate | date: 'yyyy-MM-dd'"
                  />
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('joiningDate')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('joiningDate')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.joiningDate') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="officeId"
                    >Office <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="officeId" data-extension-safe>
                    <option selected value="">Select Office</option>
                    <option *ngFor="let office of offices$ | async" [value]="office.id">
                      {{ office.officeName | capitalize }}
                    </option>
                    <!-- <option>Guillory</option>
                    <option>Jami</option> -->
                  </select>
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('officeId')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('officeId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.officeId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="departmentId"
                    >Department <span class="text-danger">*</span></label
                  >
                  <select
                    data-extension-safe
                    class="form-select"
                    formControlName="departmentId"
                    [(ngModel)]="selectedDepartmentId"
                    (change)="onDepartmentChange(selectedDepartmentId)"
                  >
                    <option value="" selected>Select Department</option>
                    <option *ngFor="let department of departments$ | async" [value]="department.id">
                      {{ department.departmentName | capitalize }}
                    </option>
                    <!-- <option>IT Management</option>
                      <option> Marketing</option> -->
                  </select>
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('departmentId')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('departmentId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.departmentId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="designationId"
                    >Designation <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="designationId" data-extension-safe>
                    <option value="" selected>Select Designation</option>
                    <option
                      *ngFor="let designation of designations$ | async"
                      [value]="designation.id"
                    >
                      {{ designation.designationName | capitalize }}
                    </option>
                    <!-- <option>IT Management</option>
                      <option> Marketing</option> -->
                  </select>
                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('designationId')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('designationId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.designationId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="gender"
                    >Gender <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="gender" data-extension-safe>
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>

                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('gender')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('gender')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.gender') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="role"
                    >Employment Type <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="role" data-extension-safe>
                    <option value="">Select Type</option>
                    <option value="Employee">Employee</option>
                    <option value="Contractor">Contractor</option>
                    <option value="Trainee">Trainee</option>
                  </select>

                  <div
                    *ngIf="
                      employeeform.get('companyInfoForm')?.get('role')?.invalid &&
                      employeeform.get('companyInfoForm')?.get('role')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.role') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label class="form-label col-lg-12"
                    >Portal Access?
                    <div class="form-check form-check-inline form-check-md form-switch me-2">
                      <label class="form-check-label mt-0">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          role="switch"
                          formControlName="portalAccess"
                          appTrimInput
                          (change)="togglePortalAccess()"
                        />
                        {{ portalAccess ? 'Yes' : 'No' }}
                      </label>
                    </div>
                  </label>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="onEmployeeSubmit()"
                  [disabled]="createloading || !employeeform.get('companyInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  <span
                    *ngIf="createloading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ createloading ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- end add employee -->

<ng-template #loading>
  <!-- <p>Loading business details...</p> -->
  <app-loader></app-loader>
</ng-template>
